import { useGet, useQueryWithErrorHandling } from '@app/sdk';

export function useCustomerByAccountNumber(accountNumber: string, silent404 = true) {
  const get = useGet(true, "cus");

  function getCustomerByAccountNumber(accountNumber: string) {
    return get<{ id: string; externalId: string; dateOfBirth: string }>(
      `/api/proxy/cus/customer-information-service/customers/accounts/${accountNumber}`
    );
  }

  return useQueryWithErrorHandling({
    queryKey: ['customer', accountNumber],
    queryFn: () => getCustomerByAccountNumber(accountNumber),
    enabled: !!accountNumber,
    silent404: silent404,
  });
}
